import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  style: {
    "width": "400px"
  }
};
import { createFormItem } from '@/component-create/utils/create-form-item';
import { FORM_ITEM } from '@/components/form/enums';
import { createTableColumn } from '@/component-create/utils/create-table-column';
import { formatter as _formatter } from '@/utils/common';
import { USER_GENDER, USER_STATUS } from '@/constant/system/code';

import { ref } from 'vue';
var url = 'demo/demo/page';
var loadUrl = 'demo/demo';
export default /*@__PURE__*/_defineComponent({
  __name: 'DemoTabelSelect',
  setup: function setup(__props) {
    var value = ref([20000, 20002]);
    var SearchItems = [createFormItem('用户名', 'username', FORM_ITEM.INPUT, {
      maxlength: '20',
      clearable: true
    }), createFormItem('手机号码', 'phoneNumber', FORM_ITEM.INPUT, {
      maxlength: '11',
      clearable: true
    }), createFormItem('状态', 'status', FORM_ITEM.SELECT, {
      loader: 'USER_STATUS',
      allOption: true,
      smartSearch: 'true'
    })];
    var column = [{
      type: 'selection'
    }, {
      label: '序号',
      type: 'index',
      width: '60'
    }, createTableColumn('用户名', 'username', '120'), createTableColumn('性别', 'gender', '60', undefined, {
      showOverflowTooltip: true,
      formatter: function formatter(row) {
        return _formatter(USER_GENDER, row.gender);
      }
    }), createTableColumn('出生日期', 'width', '100', 'center'), createTableColumn('邮箱', 'email', '200', undefined, {
      showOverflowTooltip: true
    }), createTableColumn('手机号码', 'phoneNumber', '200', 'center'), createTableColumn('状态', 'status', undefined, 'center', {
      showOverflowTooltip: true,
      formatter: function formatter(row) {
        return _formatter(USER_STATUS, row.status);
      }
    })];
    return function (_ctx, _cache) {
      var _component_XTableSelect = _resolveComponent("XTableSelect");
      var _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_XTableSelect, {
            modelValue: _unref(value),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(value) ? value.value = $event : null;
            }),
            url: url,
            loadUrl: loadUrl,
            tabelColunm: column,
            searchItems: SearchItems,
            labelkey: "username",
            valuekey: "id"
          }, null, 8, ["modelValue"]), _createElementVNode("p", null, _toDisplayString(_unref(value)), 1)])];
        }),
        _: 1
      });
    };
  }
});